import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "contact",
  class: "contact section"
}
const _hoisted_2 = {
  class: "container",
  "data-aos": "fade",
  "data-aos-delay": "100"
}
const _hoisted_3 = { class: "row gy-4" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "row gy-4" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "col-md-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "container section-title",
      "data-aos": "fade-up"
    }, [
      _createElementVNode("h2", null, "Reclamation"),
      _createElementVNode("p", null, "Envoyez-nous vos réclamations ou suggestions de façon anonyme")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"col-lg-4\"><div class=\"info-item d-flex\" data-aos=\"fade-up\" data-aos-delay=\"200\"><i class=\"bi bi-geo-alt flex-shrink-0\"></i><div><h3>Localisation</h3><p>Immeuble magasin Top Sport <br> Awlanléko, ilot 611-562<br> Maison Loukman SANI AGATHA</p></div></div><div class=\"info-item d-flex\" data-aos=\"fade-up\" data-aos-delay=\"300\"><i class=\"bi bi-telephone flex-shrink-0\"></i><div><h3>Téléphone</h3><p>+229 01 55 32 88 88 </p></div></div><div class=\"info-item d-flex\" data-aos=\"fade-up\" data-aos-delay=\"400\"><i class=\"bi bi-envelope flex-shrink-0\"></i><div><h3>Courrier</h3><p>anagemcontact@gouv.bj</p></div></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            onSubmit: _ctx.submitReclamation,
            "validation-schema": _ctx.reclamationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "nom",
                    type: "text",
                    class: "form-control",
                    placeholder: "Veuillez renseigner votre nom et prénom"
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "nom",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Field, {
                    name: "email",
                    type: "email",
                    class: "form-control",
                    placeholder: "Votre mail",
                    required: ""
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "email",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Field, {
                    name: "objet",
                    type: "text",
                    class: "form-control",
                    placeholder: "L'objet de votre message",
                    required: ""
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "objet",
                    class: "text-danger"
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    name: "message",
                    as: "textarea",
                    class: "form-control",
                    rows: "6",
                    placeholder: "Votre message",
                    required: ""
                  }),
                  _createVNode(_component_ErrorMessage, {
                    name: "message",
                    class: "text-danger"
                  })
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-md-12 text-center" }, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "btn btn-success"
                  }, "Envoyer")
                ], -1))
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}